export enum TransactionalCreditPages {
  Document,
  Form,
  Result,
}
